import { ArrowRight } from "lucide-react";
import { Screen } from "../components/Screen";
import { Reveal } from "../components/Reveal";
import { Ref } from "../components/Ref";
import { Placeholder } from "../components/Placeholder";
import { useSnak, type RefTarget } from "../snak/SnakContext";
import { mintResultsDetail, clinicalEvidenceDetail } from "../content/details";
export function P8Invitation() {
  const {
    openDetail,
    openRefs
  } = useSnak();
  const links: {
    label: string;
    target: RefTarget;
  }[] = [{
    label: "Full references",
    target: null
  }, {
    label: "Study limitations",
    target: "limitations"
  }, {
    label: "Prescribing & safety information",
    target: "pi"
  }];
  return <Screen overline="The invitation" footnote={<p data-id="element-500" data-mp="1c2lrx193a55j">
          MINT is an observational, non-randomised study; figures are provisional and subject to verification against the
          full final study materials.<Ref n={1} data-id="element-501" data-mp="24l0vuckxjspm" /> No superiority over other treatments is implied. Non-branded version — not
          approved HCP promotional material. For healthcare professionals in Germany, Austria and Switzerland.{" "}
          <Placeholder data-id="element-502" data-mp="d4670cnsmjpo">job code, date of preparation</Placeholder>
        </p>} data-id="element-499" data-mp="1c46kwmfr9g1a">
      <Reveal delay={0.1} data-id="element-503" data-mp="qvbbbs23w06c">
        <h1 className="mt-8 font-display text-[46px] font-medium leading-[1.02] tracking-[-0.015em]" data-id="element-504" data-mp="qvkqslpiyoxs">
          New evidence deserves <em className="font-medium text-[var(--s-accent)]" data-id="element-505" data-mp="m1qe428c7a87">a closer look.</em>
        </h1>
      </Reveal>
      <Reveal delay={0.2} data-id="element-506" data-mp="vtctmarpjvgr">
        <p className="mt-5 text-[17px] leading-relaxed" data-id="element-507" data-mp="vu5rem8ovamr">
          Explore the full findings and their relevance to appropriate care for patients with MF and SS.
        </p>
      </Reveal>

      <Reveal delay={0.35} data-id="element-508" data-mp="15r0rvaoivl3o">
        <div className="mt-9 flex flex-col gap-3" data-id="element-509" data-mp="15svb8kk5b55n">
          <button onClick={() => openDetail(mintResultsDetail)} className="group flex h-14 items-center justify-between rounded-full bg-[var(--s-fg)] px-6 text-[13px] font-semibold uppercase tracking-[0.16em] text-[var(--s-bg)] transition-opacity duration-150 hover:opacity-90" data-id="element-510" data-mp="3bkimwohqc7hm">
            Explore MINT Results
            <ArrowRight className="h-5 w-5 transition-transform duration-150 group-hover:translate-x-0.5" strokeWidth={1.75} data-id="element-511" data-mp="1fi5frniro2ik" />
          </button>
          <button onClick={() => openDetail(clinicalEvidenceDetail)} className="flex h-14 items-center justify-between rounded-full border border-[var(--s-fg)] px-6 text-[13px] font-semibold uppercase tracking-[0.16em] transition-colors duration-150 hover:bg-white/10" data-id="element-512" data-mp="1pfjunip1kj8r">
            Review Clinical Evidence
            <ArrowRight className="h-5 w-5" strokeWidth={1.75} data-id="element-513" data-mp="237zrg1rcnl18" />
          </button>
        </div>
      </Reveal>

      <Reveal delay={0.5} data-id="element-514" data-mp="284q8osew4mo8">
        <ul className="mt-9 border-t border-[var(--s-rule)]" data-id="element-515" data-mp="28846dncm07pc">
          {links.map(({
          label,
          target
        }) => <li key={label} className="border-b border-[var(--s-rule)]" data-id="element-516" data-mp="2d3b9ou1yvadq">
              <button onClick={() => openRefs(target)} className="group flex w-full items-center justify-between gap-3 py-3.5 text-left text-[15px]" data-id="element-517" data-mp="2h6zdr2re3nu8">
                {label}
                <ArrowRight className="h-4 w-4 opacity-70 transition-transform duration-150 group-hover:translate-x-0.5" strokeWidth={1.5} data-id="element-518" data-mp="1k59s2s6755a" />
              </button>
            </li>)}
        </ul>
      </Reveal>
    </Screen>;
}